
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.604 46.5A8.604 1.5 0 0116 48a8.604 1.5 0 01-8.604-1.5A8.604 1.5 0 0116 45a8.604 1.5 0 018.604 1.5z","fill":"#000101","fill-opacity":".389"}}),_c('path',{staticClass:"body",attrs:{"d":"M2.475 23.593L15.999 46.76l13.343-22.868c5.345-10.202-1.89-22.297-13.343-22.317C4.695 1.606-2.56 13.205 2.475 23.593z","fill":"#109cdc","stroke":"#fff","stroke-width":"1.25"}}),_c('path',{attrs:{"d":"M27.126 16.76a11.131 11.131 0 01-11.131 11.13A11.131 11.131 0 014.864 16.76a11.131 11.131 0 0111.13-11.13 11.131 11.131 0 0111.132 11.13z","fill":"none","stroke":"#333","stroke-width":".846","stroke-opacity":".581"}}),_c('path',{attrs:{"d":"M15.995 46.752l13.343-22.868C34.69 13.682 27.586 1.638 15.995 1.567z","fill":"#fff","fill-opacity":".237"}}),_c('path',{attrs:{"d":"M24.583 16.76a8.588 8.588 0 01-8.588 8.588 8.588 8.588 0 01-8.589-8.588 8.588 8.588 0 018.589-8.588 8.588 8.588 0 018.588 8.588z","fill":"none","stroke":"#fff","stroke-width":"4.231"}})])
          )
        }
      }
    